module.exports = __webpack_public_path__ + "static/img/blbhLogo.457fcc4a.png";